module.exports = __webpack_public_path__ + "static/ChubbTech-952c2ba536a7dcb4aea0c43c2b8e2034.png";